var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_65_2754)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.4167 6.6667H9.16667V11.6667L13.125 14.0417L13.75 13.0167L10.4167 11.0417V6.6667ZM14.4475 1.50836L18.2867 4.71253L17.22 5.9917L13.3783 2.7892L14.4475 1.50836ZM5.55251 1.50836L6.62084 2.78836L2.78084 5.9917L1.71417 4.7117L5.55251 1.50836ZM10 3.33336C5.85834 3.33336 2.50001 6.6917 2.50001 10.8334C2.50001 14.975 5.85834 18.3334 10 18.3334C14.1417 18.3334 17.5 14.975 17.5 10.8334C17.5 6.6917 14.1417 3.33336 10 3.33336ZM10 16.6667C6.78334 16.6667 4.16667 14.05 4.16667 10.8334C4.16667 7.6167 6.78334 5.00003 10 5.00003C13.2167 5.00003 15.8333 7.6167 15.8333 10.8334C15.8333 14.05 13.2167 16.6667 10 16.6667Z",
    fill: "#F1F1F1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_65_2754"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClock);
export default __webpack_public_path__ + "static/media/icon-clock.2cafe85f6fde4aacdfdd0037df3840fc.svg";
export { ForwardRef as ReactComponent };